import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import MyDesignsTable from './MyDesignsTable';
import Dialog from '../../Dialog';
import { useTranslation } from 'react-i18next';

const MyDesignsDialog = props => {
	const { t } = useTranslation();
	const { open, setOpen } = props;
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Dialog
			open={open}
			handleClose={handleClose}
			fullScreen={fullScreen}
			maxWidth={'xl'}
			title={t('components.navbar.userMenu.texts.myDesigns')}
			content={<MyDesignsTable closeDialog={handleClose} />}
		/>
	);
};

MyDesignsDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired
};

export default MyDesignsDialog;
